<template>
    <a v-if="selectedLanguaged == 'eng'" class="white--text" @click="setLanguage('srb')">
              Srpski
            </a>
            <a v-else class="white--text" @click="setLanguage('eng')">
              English
            </a>
    <!--<select v-model="$i18n.locale" class="white--text" @change="changeLanguage">
        <option value="srb" class="black--text">Srpski</option>
        <option value="eng" class="black--text">English</option>
    </select>-->
</template>

<script>
export default {
    data(){
        return {
            selectedLanguaged: localStorage.getItem('language')
        }
    },
    methods:{
        changeLanguage(obj) {
            localStorage.setItem('language',obj.target.value);
        },
        setLanguage(language) {
            localStorage.setItem('language',language);
            this.selectedLanguaged = language;
            this.$i18n.locale = language;
        }
    }
}
</script>
